export const common = {
  loading: 'Loading...',
  save: 'Save',
  cancel: 'Cancel',
  close: 'Close',
  confirm: 'Confirm',
  delete: 'Delete',
  edit: 'Edit',
  back: 'Back',
  next: 'Next',
  submit: 'Save',
  search: 'Search',
  filter: 'Filter',
  sort: 'Sort',
  more: 'More',
  less: 'Less',
  yes: 'Yes',
  no: 'No',
  ok: 'Done',
  error: 'Error',
  success: 'Success',
  warning: 'Warning',
  info: 'Info',
  
  // Global loading states
  loadingData: 'Loading dashboard data...',
  loadError: 'Failed to load dashboard data',
  retry: 'Retry',
};

export const timeAgo = {
  today: 'today',
  yesterday: 'yesterday',
  daysAgo: '{count} days ago',
  weekAgo: '1 week ago',
  weeksAgo: '{count} weeks ago',
  monthAgo: '1 month ago',
  monthsAgo: '{count} months ago',
};
